import styled from 'styled-components';

import { sp } from '@main/theme';

/**
 * The Side wrapper to contain icon
 */
export const SideWrapper = styled.div`
  padding-top: ${sp(1)};
`;

/**
 * The Icon wrapper
 */
export const IconWrapper = styled.div`
  width: ${sp(5)};
`;

/**
 * The Text wrapper
 */
export const TextWrapper = styled.div`
  margin-left: ${sp(2.2)};
  margin-top: ${sp(0.6)};
`;

/**
 * The TitleWrapper wrapper
 */
export const TitleWrapper = styled.h1`
  margin: 0;
  font-size: ${sp(2)};
  line-height: ${sp(2.75)};
`;

/**
 * The Description wrapper
 */
export const DescriptionWrapper = styled.p`
  font-size: ${sp(1.5)};
  margin-bottom: ${sp(1.5)};
`;

/**
 * The Timestamp wrapper
 */
export const TimestampWrapper = styled.p`
  font-size: ${sp(1.4)};
  padding: 0;
  margin-top: ${sp(0.5)};
  color: ${({ theme }) => theme.colors.transcendNavy3};
`;

/**
 * The Button panel wrapper
 */
export const ButtonPanelWrapper = styled.div``;

/**
 * The Button wrapper
 */
export const ButtonWrapper = styled.div`
  margin-bottom: 7px;

  button {
    font-size: 14px;
  }
`;

/**
 * The RequestPreview wrapper
 */
export const RequestPreviewWrapper = styled.section`
  display: flex;
  flex-direction: row;
  padding: ${sp(1)} ${sp(1)} ${sp(3)} ${sp(1)};
`;
